import { AdditionalInterest } from "@covertree/new-business-graphql";

/**
 * Checks if the lot/unit field contains a prefix like "lot", "unit", "apt", or "#"
 * @param lotUnit - String containing lotUnit
 * @returns Boolean indicating if the lotUnit contains a prefix
 */
const containsLotUnitPrefix = (lotUnit: string) => {
  const lowerCaseLotUnit = lotUnit.toLowerCase();

  return (
    lowerCaseLotUnit.includes("lot") ||
    lowerCaseLotUnit.includes("unit") ||
    lowerCaseLotUnit.includes("apt") ||
    lowerCaseLotUnit.includes("#")
  );
};

/**
 * Formats an additional interest's address into a single string
 * @param additionalInterest - Additional interest form data containing address fields
 * @returns Formatted address string with all address components joined by commas
 */
const formatAdditionalInterestAddress = (
  additionalInterest: Omit<AdditionalInterest, "additionalInterestId">
) => {
  const { streetAddress, lotUnit, city, state, zipCode } = additionalInterest;

  const formattedLotUnit = lotUnit
    ? containsLotUnitPrefix(lotUnit)
      ? `${lotUnit},`
      : `# ${lotUnit},`
    : "";

  return `${streetAddress}, ${formattedLotUnit} ${city}, ${state} ${zipCode}`;
};

export { formatAdditionalInterestAddress };
